module.exports = __webpack_public_path__ + "static/media/numbers.919735d8.jpg";